/* eslint-disable react/no-multi-comp */
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from "react-router";

import { AccountProfile, AccountDetails, Payment } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const renderNotSubscribed = (user)=>{
  return(
    <div>
      <Grid container spacing={2}>
        <Grid
          item
          md={5}
          xs={12}
        >
          <Grid
            item
            lg={12}
            md={12}
            xl={12}
            xs={12}
          >
            <AccountProfile user= {user} />
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            xl={12}
            xs={12}
          >
            <Payment user= {user}/>
          </Grid>
        </Grid>
        <Grid
          item
          md={7}
        >
          <AccountDetails user={user} />
        </Grid>
      </Grid>
    </div>
  )
}

const renderSubscribed = (user)=>{
  return(
    <div>
      <Grid
        container
        spacing={4}
      >
        <Grid
          item
          lg={4}
          md={4}
          xl={4}
          xs={12}
        >
          <AccountProfile user= {user} />
        </Grid>
        <Grid
          item
          lg={8}
          md={6}
          xl={8}
          xs={12}
        >
          <AccountDetails user= {user} />
        </Grid>
      </Grid>
    </div>
  )
}

const Account = (props) => {
  const history = useHistory();
  const { user } = props;
  const classes = useStyles();
  if(!user){
    history.push('/sign-in')
  }
  if(!(typeof(user)==='object'))
  {
    return(
      <div style={{position:'absolute',left:'55%',top:'45%'}}>
        <CircularProgress
          size={80}
          thickness={3.8}
        />
      </div>
    )
  }

  return (
    <div className={classes.root}>
      {user.subscribed ? renderSubscribed(user) : renderNotSubscribed(user)}
    </div>
  );
};

export default Account;
